<template>
  <div class="wrapper" style="background: none">
    <dash-header></dash-header>
    <sidebar></sidebar>
    <div class="content-wrapper p-3" style="background: none">
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-12">
              <h1 class="m-2" style="font-weight: bold; font-size: 35px">
                Withdraw
              </h1>
            <div class="row">
                <div class="col-lg-12">
                    <div class="card data-bank__card p-3">
                        <h2 style="font-weight:bold">Deposit</h2>
                        <h3 class="data-bank__nominal">$ 2.000.000</h3>
                    </div>
                </div>
            </div>
            <div class="row">
                   <div class="col-lg-8">
                    <div class="card data-bank__card p-3">
                        <h2 class="data-bank__heading">History</h2>
                        <hr>
                      <img class="images_icon" src="../assets/money.png" />
                      <div class="data-bank__text">
                        <h2 class="data-bank__text-name">
                          -$50
                        </h2>
                        <h2 class="data-bank__bank-name">Bank BTN</h2>
                        <p class="data-bank__bank-code">Balance Withdraw @sffs$fbsfs%Fsmfs3f,ssfs </p>
                      <hr class="line_dotted">
                      <p class="data-bank__text-balance">Balance Now $180.150</p>
                      <hr class="thick_line">
                      </div>
                       <img class="images_icon" src="../assets/money.png" />
                      <div class="data-bank__text">
                        <h2 class="data-bank__text-name">
                          -$50
                        </h2>
                        <h2 class="data-bank__bank-name">Bank BTN</h2>
                        <p class="data-bank__bank-code">Balance Withdraw @sffs$fbsfs%Fsmfs3f,ssfs </p>
                      <hr class="line_dotted">
                      <p class="data-bank__text-balance">Balance Now $180.150</p>
                      <hr class="thick_line">
                      </div>
                    </div>
                </div>
                <div class="col lg-8">
                    <div class="card data-bank__card p-3">
                        <h2 class="data-bank__heading">Withdraw With</h2>
                        <div class="card card__withdraw-with p-3">
                            <h2 class="heading__withdraw-with">A.N Anonimtrade</h2>
                            <h3 class="heading__withdraw-with-bank">Bank BTN</h3>
                            <h3 class="heading__withdraw-with mt-2">No. Rek</h3>
                            <h3 class="heading__withdraw-nominal">15600009861578</h3>
                             <h3 class="heading__withdraw-with mt-2">Indonesia, Bali</h3>
                        </div>
                        <div class="card card-not-choose__withdraw-with p-3">
                            <h2 class="heading__withdraw-with">A.N Anonimtrade</h2>
                            <h3 class="heading__withdraw-with-bank">Bank BTN</h3>
                            <h3 class="heading__withdraw-with mt-2">No. Rek</h3>
                            <h3 class="heading__withdraw-nominal">15600009861578</h3>
                             <h3 class="heading__withdraw-with mt-2">Indonesia, Bali</h3>
                        </div>
                    </div>
                    <button class="btn btn-danger btn_withdraw p-3">WITHDRAW</button>
                </div>
            </div>
              
            </div>
          </div>
        </div>
      </div>
      <section class="content"></section>
    </div>
    <!-- <dash-footer></dash-footer> -->
  </div>
</template>
<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import { dragscroll } from "vue-dragscroll";
export default {
  directives: {
    dragscroll,
  },
  name: "Databank",
  components: {
    DashHeader,
    // DashFooter,
    Sidebar,
  },
};
</script>
<style>
.data-bank__card{
    border-radius: 15px;
    position: relative;
}
.data-bank__nominal{
    font-weight:bold;
    margin-left:300px;
    font-size:40px
}
.data-bank__heading{
    font-weight: 600;
    font-size: 30px;
}
.images_icon {
  width: 30px;
  margin-left: 2px;
  height: 30px;
  object-fit: cover;
  text-align: center;
}
.data-bank__text {
  text-align: left; 
}
.data-bank__text-name {
  margin-top: 20px;
  font-size: 14px;
  margin-left: 40px;
  margin-top: -19px;
  color: red;
  font-weight: 700;
}
.data-bank__bank-name{
    font-weight: 600;
    font-size: 24px;
    margin-left: 0;
}
.data-bank__bank-code{
    margin-top: 20px;
    font-size: 13px;
    font-weight: 700;
}
.line_dotted{
 border:none;
  border-top:3px dashed rgba(0, 0, 0, 0.3);
  background-color:#fff;
  height:10px;
  width:100%;
}
.data-bank__text-balance{
    font-size: 13px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.3);
}
.thick_line{
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
    border-top: 3px solid black;
    width: 100%;
}
.card__withdraw-with{
  background: rgba(0, 0, 0, 0.5);
    border-radius: 9px;
}
.heading__withdraw-with{
    color: black;
    font-size: 13px;
    font-weight: 700;
}
.heading__withdraw-with-bank{
    color: black;
    font-size: 13px;
    font-weight: 700;
    text-align: right;
    margin-top: -24px;
}
.heading__withdraw-nominal{
    color: black;
    font-weight: 700;
    margin-left: 10px;
    font-size: 25px;
}
.card-not-choose__withdraw-with{
    background: #ECECEC;
    border-radius: 9px;
    margin-top: -5px;
}
.btn_withdraw{
    background: #E32525;
    border-radius: 9px;
    width: 100%;
    font-weight: 600;
    font-size: 30px;
}   
</style>